import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoachAiName } from 'utils/i18n';
import createLocation from 'utils/createLocation';
import Box from 'components/Box';
import Button from 'components/Button';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import { COACH_AI_ROUTE } from 'utils/routes';
import { SearchWidgetCard } from './SearchWidgetCard';
import useSearchParameter from 'hooks/useSearchParameter';
export function CoachAiLauncherWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  var coachAiName = getCoachAiName();
  return /*#__PURE__*/React.createElement(SearchWidgetCard, {
    icon: /*#__PURE__*/React.createElement(CoachAiAvatar, null),
    title: coachAiName
  }, /*#__PURE__*/React.createElement(Box, {
    as: "p",
    style: {
      whiteSpace: 'pre-wrap'
    },
    my: "xs"
  }, t('coach_ai_ask_about', {
    coachAiName: coachAiName,
    searchInput: q
  })), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    iconRight: "arrow-right",
    variant: "primary",
    as: Link,
    to: createLocation(COACH_AI_ROUTE, {
      q: q
    })
  }, t('coach_ai_ask', {
    coachAiName: coachAiName
  })));
}